export const SMALL_SCREEN_WIDTH = 776;
export const SMALL_SCREEN_HEIGHT = 485;
